enum TagPickerType {
  Roles = "roles",
  Organizations = "organizations",
  Responsibilities = "responsibilities",
  Terminals = "terminals",
  Users = "users",
  Channel = "channels",
  Kpi = "kpi",
  Airlines = "airlines",
}

const TagPickerEnum = {
  TagPickerType,
};

export default TagPickerEnum;
